<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/add-user"
        >
          Nouveau Utilisateur
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
        <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Export
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control text-black rounded-0"
          placeholder="Chercher"
          v-model="users.searchTerm"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>
          <span v-else-if="props.column.field == 'logout_time'">
            {{ props.row.logout_time ? getDate(props.row.logout_time) : "" }}
          </span>
          <span v-else-if="props.column.field == 'active'">
            <div class="switch" v-if="auth.can('EDIT_USER')">
              <input
                type="checkbox"
                class="switch-input"
                :id="'switch-' + props.row.id"
                :checked="props.row.active"
                @change="toggleAdActive(props.row)"
              />
              <label
                class="switch-label"
                :for="'switch-' + props.row.id"
              ></label>
            </div>
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <!-- <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Voir
                  </a>
                </li> -->
                <li v-if="auth.can('EDIT_USER')">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="
                      $router.push({
                        name: 'EditUserPage',
                        params: { id: props.row.id },
                      })
                    "
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="
                      $router.push({
                        name: 'HistoryUserPage',
                        params: { id: props.row.id },
                      })
                    "
                  >
                    <i
                      class="flaticon-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    Historique
                  </a>
                </li>
                <!-- <li>
                <a
                  class="dropdown-item d-flex align-items-center"
                  href="javascript:void(0);"
                >
                  <i
                    class="flaticon-delete lh-1 me-8 position-relative top-1"
                  ></i>
                  Supprimer
                </a>
              </li> -->
              </ul>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>
  <!-- <CreateNewUserModal /> -->
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
// import PaginatorContent from "@/components/PaginatorContent.vue";

export default defineComponent({
  name: "UsersList",
  components: {
    // CreateNewUserModal,
  },
  setup: () => {
    const { showToast } = useAppToast();
     const auth = useAuthStore();
    const user = auth.user;

    const headers = [
      {
        label: "Nom Complet",
        field: "name",
      },
      {
        label: "Email",
        field: "email",
      },
      {
        label: "Téléphone",
        field: "phone",
      },
      {
        label: "Fonction",
        field: "type",
      },
      {
        label: "Date Création",
        field: "created_at",
      },
      // {
      //   label: "Informations",
      //   field: "info",
      // },
      {
        label: "Dernière Connexion",
        field: "logout_time",
      },

      {
        label: "Statut",
        field: "active",
      },

      {
        label: "Action",
        field: "actions",
      },
    ];

    const rows = ref([]);
    const loading = ref(false);

    const users = reactive({
      searchTerm: "",
      searchName: "",
      searchFunction: "",
      searchCity: "",
      searchUser: "",
      searchAgency: "",
      searchDateFrom: "",
      searchDateTo: "",
      searchAccount: "",
      searchConnect: "",
      searchSlDate: "",
      searchElDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/users`, {
          params: {
            searchTerm: users.searchTerm,
            searchName: users.searchName,
            searchFunction: users.searchFunction,
            searchCity: users.searchCity,
            searchUser: users.searchUser,
            searchAgency: users.searchAgency,
            searchDateFrom: users.searchDateFrom,
            searchAccount: users.searchAccount,
            searchConnect: users.searchConnect,
            searchSlDate: users.searchSlDate,
            searchElDate: users.searchElDate,

            page: users.current_page,
            per_page: users.per_page,
          },
        });

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
    });

    let searchTimeout: ReturnType<typeof setTimeout> | null = null;
    watch(() => users.searchTerm, () => {
      if (searchTimeout) clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => fetchData(1), 400);
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function toggleAdActive(row) {
      Swal.fire({
        text: "Vous voulez désactiver ce compte ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui, désactiver!",
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const res = await api.post(`/api/auth/user_active/${row.id}`, {
            active: Number(!row.active),
          });
          if (res.data.message == "success"){
            fetchData();
             showToast("Utilisateur est bien modifé", "success");

          }
        } else if (result.isDenied) {
          // const item = rows.value.find((z) => z.id === row.id);
          // if(item){
          //   item.active = row.active;
          // }
        }
      });
    }

    async function openEdit(id) {
      // Logic to open edit modal or navigate to edit page
      console.log("Edit user with ID:", id);
      // For example, navigate to edit page
      window.location.href = `/edit-user/${id}`;
    }

    return {
      rows,
      headers,
      fetchData,
      getDate,
      loading,
      users,
      toggleAdActive,
      openEdit,

      auth,
      user,
    };
  },
});
</script>